import { loadEnd, loadStart } from '../../exports/bi';
import { ReportBI } from '../../services';
import { withoutDefaults } from '../../util';
import { CollectionPageState } from './CollectionPageState';

export interface CollectionPageStateBIReporterParams {
  reportBI: ReportBI;
  collectionPageState: CollectionPageState;
}

export class CollectionPageStateBIReporter {
  readonly collectionPageState: CollectionPageState;
  readonly reportBI: ReportBI;
  appLoaded?: () => void;

  constructor(params: CollectionPageStateBIReporterParams) {
    this.collectionPageState = params.collectionPageState;
    this.reportBI = params.reportBI;
  }

  init() {
    const startTime = performance.now();
    this.appLoaded = this.reportOnLoadStart(startTime);
  }

  reportOnLoadStart(startTime: number) {
    this.reportBI(
      withoutDefaults(loadStart)({
        ...this._commonDynamicBiParams(),
      }),
    );
    return () => {
      this.reportOnLoadEnd(Math.round(performance.now() - startTime));
    };
  }

  reportOnLoadEnd(endTime: number) {
    this.reportBI(
      withoutDefaults(loadEnd)({
        ...this._commonDynamicBiParams(),
        loadingTime: endTime,
      }),
    );
  }

  _commonDynamicBiParams() {
    return {
      url: window.location.href,
      route: window.location.pathname,
      routerUsage: this.collectionPageState.withinRouter,
    };
  }
}
